import { useContext } from 'react'
import { CopilotApi, CopilotContext } from '../state/CopilotContext'

export function useCopilot(): CopilotApi {
  const ctx = useContext(CopilotContext)
  if (!ctx) throw new Error('useCopilot must be used within <CopilotProvider>')
  return ctx
}
